import { render, staticRenderFns } from "./MarketPlaces.vue?vue&type=template&id=54f5f794&scoped=true&"
import script from "./MarketPlaces.vue?vue&type=script&lang=js&"
export * from "./MarketPlaces.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlaces.vue?vue&type=style&index=0&id=54f5f794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5f794",
  null
  
)

export default component.exports